import React from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
// Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { logout } from "../../reducers/authSlice"; // Redux Toolkit action creator
import { withRouter } from "../../utils/withRouter";
import PageTitle from "../page-title/PageTitle";

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  sidebarToggle() {
    // Note: Using jQuery for DOM manipulation is discouraged in React, but kept here to avoid disturbing the original structure.
    $(".sidebar-offcanvas").toggleClass("active");
  }

  _logout = async () => {
    // 1. Calling the `logout` prop (now wrapped in dispatch by connect)
    await this.props.logout(); 
    // 2. Redirect
    this.props.navigate("/admin/login");
  };

  getPageName = () => {
    // ... (This function is fine)
    const pageRoutes = this.props.location.pathname;
    const lastString = pageRoutes.substring(pageRoutes.lastIndexOf("/") + 1);
    const result = lastString
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return result ? result : "Welcome";
  };
  
  render() {
    const { user } = this.props.auth;

    // The rest of the render method is unchanged for minimal disturbance.
    return (
      <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div className="navbar-brand-wrapper d-flex align-items-center">
          <Link className="navbar-brand brand-logo" to="/">
            <img
              src="/assets/images/sundial-logo.svg"
              alt="logo"
              className="logo-dark"
              draggable={false}
            />
          </Link>
          <Link className="navbar-brand brand-logo-mini" to="/">
            <img src="/assets/images/logo-mini.svg" alt="logo" />
          </Link>
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-center flex-grow-1">
          <PageTitle pageName={this.getPageName()} />

          <ul className="navbar-nav navbar-nav-right ml-auto">
            <li className="nav-item dropdown d-none d-xl-inline-flex user-dropdown">
              <a
                className="nav-link dropdown-toggle"
                id="UserDropdown"
                 href="/admin/home"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  className="img-xs rounded-circle ml-2"
                  alt="user avatar"
                  src={`https://ui-avatars.com/api/?background=38ce3c&color=fff&name=${"Admin"}`}
                />

                <span className="font-weight-normal">
                  {" "}
                  {user && user.fullName}{" "}
                </span>
              </a>
              <div
                className="dropdown-menu dropdown-menu-right navbar-dropdown"
                aria-labelledby="UserDropdown"
              >
                <div className="dropdown-header text-center">
                  <img
                    className="img-md rounded-circle"
                    alt="user avatar"
                    src={`https://ui-avatars.com/api/?background=38ce3c&color=fff&name=${"Admin"}`}
                    width={100}
                  />
                  <p className="mb-1 mt-3">{user && user.fullName}</p>
                  <p className="font-weight-light text-muted mb-0">
                    {user && user.email}
                  </p>
                </div>

                <a
                  className="dropdown-item"
                  href="/admin/home"
                  onClick={(e) => {
                    e.preventDefault();
                    this._logout();
                  }}
                >
                  <i className="dropdown-item-icon icon-power text-primary" />
                  Sign Out
                </a>
              </div>
            </li>
          </ul>
          <button
            className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            data-toggle="offcanvas"
            onClick={() => {
              this.sidebarToggle();
            }}
          >
            <span className="icon-menu" />
          </button>
        </div>
      </nav>
    );
  }
}

// 2. Corrected PropType Definition to apply to the component
Navbar.propTypes = {
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired, // Added auth prop type for completeness
  navigate: PropTypes.func.isRequired, // Added navigate prop type from withRouter
  location: PropTypes.object.isRequired, // Added location prop type from withRouter
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

// 1. RESOLUTION: Simply map the action creator directly to be wrapped by connect
const mapDispatchToProps = {
  logout, // Equivalent to: logout: (...args) => dispatch(logout(...args))
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));